// Independent Variables (input-only)
export const OD_Free = 0;
export const Wire_Dia = 1;
export const Coils_T = 2;
export const Initial_Tension = 3;
export const End_Extension = 4;
export const Force_1 = 5;
export const Force_2 = 6;

// Dependent Variables (input-output)
export const Mean_Dia = 0;
export const ID_Free = 1;
export const Coils_A = 2;
export const Rate = 3;
export const Deflect_1 = 4;
export const Deflect_2 = 5;
export const L_Body = 6;
export const L_Free = 7;
export const L_1 = 8;
export const L_2 = 9;
export const L_Stroke = 10;
export const Weight = 11;
export const Spring_Index = 12;
export const Stress_Initial = 13;
export const Stress_1 = 14;
export const Stress_2 = 15;
export const Stress_Hook = 16;
export const FS_2 = 17;
export const FS_CycleLife = 18;
export const FS_Hook = 19;
export const Cycle_Life = 20;
export const PC_Safe_Deflect = 21;
export const Stress_Init_Lo = 22;
export const Stress_Init_Hi = 23;
export const Energy = 24;
export const Spring_Type = 25;
export const Prop_Calc_Method = 26;
export const Material_Type = 27;
export const ASTM_Fed_Spec = 28;
export const Process = 29;
export const Material_File = 30;
export const Life_Category = 31;
export const Density = 32;
export const Torsion_Modulus = 33;
export const Hot_Factor_Kh = 34;
export const Tensile = 35;
export const PC_Tensile_Endur = 36;
export const PC_Tensile_Stat = 37;
export const PC_Tensile_Bend = 38;
export const Stress_Lim_Endur = 39;
export const Stress_Lim_Stat = 40;
export const Stress_Lim_Bend = 41;
export const SI_Range = 42;
export const SI_Lo_Factor = 43;
export const SI_Hi_Factor = 44;
export const End_Type = 45;
export const End_ID = 46;
export const Extended_End_ID = 47;
export const L_End = 48;
export const L_Extended_End = 49;
export const Hook_Deflect_All = 50;
export const Catalog_Name = 51;
export const Catalog_Number = 52;
export const tbase010 = 53;
export const tbase400 = 54;
export const const_term = 55;
export const slope_term = 56;
export const tensile_010 = 57;